import api from './client';

export type BarcodeScanOutcome = 'added' | 'rejected' | 'awaiting_binding' | 'dismissed';

export interface BarcodeKnowledge {
  catalog_id?: number | null;
  gtin?: string | null;
  status: string;
  good_status?: string | null;
  source: 'national_catalog';
  brand?: string | null;
  model_name?: string | null;
  good_name?: string | null;
  suggested_search?: string | null;
  description?: string | null;
  container_size?: string | null;
  manufacturer?: string | null;
  country?: string | null;
  attributes: { id?: number | null; name: string; value: string; unit?: string | null }[];
  image_urls: string[];
}

export interface BarcodeScan {
  id: number;
  raw_code: string;
  scanned_at: string;
  handled_at?: string | null;
  outcome?: BarcodeScanOutcome | null;
  product?: BarcodeProduct;
  knowledge?: BarcodeKnowledge | null;
}

export interface BarcodeProduct {
  barcode: string;
  id: string;
  name: string;
  article?: string | null;
  unit_name?: string | null;
  price?: number | null;
  price_from_price_list?: boolean;
  type?: string | null;
  requires_data_matrix: boolean;
  knowledge?: BarcodeKnowledge | null;
}

export const barcodeScanApi = {
  create: (raw_code: string) =>
    api.post<BarcodeScan>('/barcode-scans', { raw_code }).then(r => r.data),

  pending: () =>
    api.get<BarcodeScan[]>('/barcode-scans/pending').then(r => r.data),

  ack: (id: number, outcome: BarcodeScanOutcome) =>
    api.post<BarcodeScan>(`/barcode-scans/${id}/ack`, { outcome }).then(r => r.data),

  getProduct: (code: string) =>
    api.get<BarcodeProduct>('/1c/barcode', { params: { code } }).then(r => r.data),

  bind: (barcode: string, product_id: string) =>
    api.put<{ barcode: string; product_id: string; product_name: string }>(
      `/1c/barcode-bindings/${encodeURIComponent(barcode)}`,
      { product_id },
    ).then(r => r.data),
};
